import { connectLiveLinks } from '../../containers/live-links-container';
import LiveLinks from './live-links';

export default connectLiveLinks(LiveLinks);
